import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme, Typography } from "@mui/material";
export const InvitationStatCard = ({ title, value, status, }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            background: theme.palette.background.neutral,
            borderRadius: 3,
            p: 2,
            width: "100%",
        }, children: [value && (_jsx(Typography, { variant: "h5", color: "text.primary", children: value })), status && (_jsx(Typography, { variant: "h5", color: "#637381", children: status })), _jsx(Typography, { variant: "subtitle2", color: "text.primary", children: title })] }));
};
